import { IconProps } from ".";
import Icon from "./assets/earth_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Earth(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
